import React from 'react'
import PropTypes from 'prop-types'
import display from 'lib/Display'
import BabaForm from 'components/forms/Index'

const NavigationButtons = ({
  previousStepURL,
  priceAfter,
  goPrevious,
  submitLabel,
  handleValidate,
  disableSubmitButton = false
}) => {
  const previousStepProp = previousStepURL
    ? { href: previousStepURL }
    : { onClick: goPrevious }

  return (
    <>
      <div className="checkout-cta-container hidden-xs">
        <div className="row">
          <div className="col-md-6 hidden-xs hidden-sm">
            <a className="link-unstyled previous-step" {...previousStepProp}>
              <span className="glyphicon glyphicon-arrow-left mr-2"></span>
              Précédent
            </a>
          </div>
          <div className="col-md-6">
            <div className="row">
              {priceAfter ? (
                <div className="col-xs-6 total">
                  <strong>Total : {display.currency(priceAfter)}</strong>
                </div>
              ) : (
                <div className="col-md-6 total">
                  <a
                    className="link-unstyled previous-step visible-xs visible-sm"
                    {...previousStepProp}>
                    <span className="glyphicon glyphicon-arrow-left mr-2"></span>
                    Précédent
                  </a>
                </div>
              )}
              <div className="col-md-6">
                {handleValidate ? (
                  <button
                    className="btn btn-primary btn-cta btn-lg pull-right"
                    onClick={handleValidate}
                    disabled={disableSubmitButton}>
                    {submitLabel}
                  </button>
                ) : (
                  <BabaForm.BabaSubmit
                    label={submitLabel}
                    buttonClasses="btn btn-primary btn-cta btn-lg pull-right"
                    disabled={disableSubmitButton}
                  />
                )}
              </div>
            </div>
            {priceAfter && (
              <div className="row visible-xs visible-sm">
                <a
                  className="link-unstyled previous-step"
                  {...previousStepProp}>
                  <span className="glyphicon glyphicon-arrow-left mr-2"></span>
                  Précédent
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="checkout-cta-container fixed">
        <div className="container">
          <div className="row">
            <div className="col-md-6 hidden-xs hidden-sm">
              <a className="link-unstyled previous-step" {...previousStepProp}>
                <span className="glyphicon glyphicon-arrow-left mr-2"></span>
                Précédent
              </a>
            </div>
            <div className="col-md-6">
              <div className="row">
                {priceAfter ? (
                  <div className="col-xs-6 total">
                    <strong>Total : {display.currency(priceAfter)}</strong>
                  </div>
                ) : (
                  <div className="col-xs-6 total">
                    <a
                      className="link-unstyled previous-step visible-xs visible-sm"
                      {...previousStepProp}>
                      <span className="glyphicon glyphicon-arrow-left mr-2"></span>
                      Précédent
                    </a>
                  </div>
                )}
                <div className="col-xs-6">
                  {handleValidate ? (
                    <button
                      className="btn btn-primary btn-cta btn-lg pull-right"
                      onClick={handleValidate}
                      disabled={disableSubmitButton}>
                      {submitLabel}
                    </button>
                  ) : (
                    <BabaForm.BabaSubmit
                      label={submitLabel}
                      buttonClasses="btn btn-primary btn-cta btn-lg pull-right"
                      disabled={disableSubmitButton}
                    />
                  )}
                </div>
              </div>
              {priceAfter && (
                <div className="row visible-xs visible-sm">
                  <a
                    className="link-unstyled previous-step"
                    {...previousStepProp}>
                    <span className="glyphicon glyphicon-arrow-left mr-2"></span>
                    Précédent
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

NavigationButtons.propTypes = {
  previousStepURL: PropTypes.string,
  priceAfter: PropTypes.string,
  goPrevious: PropTypes.func.isRequired,
  submitLabel: PropTypes.string.isRequired,
  handleValidate: PropTypes.func,
  disableSubmitButton: PropTypes.bool
}

NavigationButtons.displayName = 'NavigationButtons'
export default NavigationButtons
